import React, { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const TableContainer = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => {
  return (
    <>
      <Typography marginTop="60px" variant="h5">
        {label}
      </Typography>
      <Box marginTop="-25px" maxWidth="1400px">
        <Box display="flex" justifyContent="center">
          <Typography variant="button" marginBottom="5px">
            Shipment Month
          </Typography>
        </Box>
        {children}
      </Box>
    </>
  );
};

export default TableContainer;
